export const messages = {
  my_files: "My Files",
  user_guide: "User Guide",
  connect_wallet: "Connect Wallet",
  home_title: "NFT Hub",
  home_sub_title:
    "Free and Decentralized Storage of Your Important NFT Content",
  powered_by: "Powered by",
  upload: "UPLOAD",
  download: "Download",
  gallery: "Gallery",
  step: "Step",
  step1_description:
    "Download and install TronLink wallet, and use it to create or import your TRON account.",
  step2_description:
    "Click 'Connect Wallet', give approval, and then log into NFT Hub.",
  step3_description_part1:
    "Upload your original NFT file. Once it is uploaded, you can view and get the URL to the content in",
  step3_description_part2: "and can mint NFT with one click.",
  partners: "Partners",
  connect_wallet_description: "Connect your wallet to use NFT Hub",
  tronlink_not_installed: "TronLink is not Installed",
  tronlink_not_login: "TronLink is not Logged in",
  connect_tronlink: "Connect TronLink",
  no_tronlink: "Don't have TronLink?",
  login_first: "Please log into TronLink wallet first",
  install_first: "Please install TronLink wallet first",
  to_install: "Install",
  login_already: "Login already",
  limit_exceed: "Limit Exceed",
  limit_description:
    "For the moment, each TRON address is able to upload a maximum of 30 files. If you're a developer and require larger file storage, please feel free to reach out to us via the email address below.",
  upload_successful: "Upload Successful",
  upload_failed: "Upload Failed",
  download_failed: "Download Failed",
  copied: "Copied!",
  file_name: "File Name",
  file_hash: "Content Address",
  size: "Size",
  type: "Type",
  total: "Total",
  type_not_supported: "Type not supported",
  size_warning: "Should be smaller than 30 M",
  created_date: "Created Time",
  copy_link: "Copy Link",
  coming_soon: "Coming Soon",
  mint_description: "One-click NFT minting is in progress. Stay tuned!",
  mint_nft: "Mint NFT",
  go_to: "Go to",
  logout: "Logout",
  upload_description1:
    "Use the button below, or drag and drop, to select a file you would like to share on the BTFS network 2.0.",
  upload_description2:
    "Maximum file size is 30MB. You can upload only one file at a time.",
  upload_type: "File types supported: ",
  upload_double_check:
    "Please double-check before uploading, there is no undo.",
  add: "Add a File",
  etc: "etc.",
  no_preview: "Preview not Supported for This File Type",
  ecosystem: "Ecosystem",
  developer: "Developer",
  community: "Community",

  // v1.1 justinsnft

  justins_nft_description:
    "Learn about the amazing content shared by Justin on BTFS",
  collections: "Collections",
  works: "Works",
  reports: "Reports",
  loading: "You have one file in loading, please wait to complete",

  // v1.1 mint

  asset: "Asset",
  name: "Name",
  category: "Category",
  description: "Description",
  description_sub: "Provide a detailed description of your item.",
  outerlink: "External Link",
  is_original: "Original Content",
  is_original_sub: "Set this item as original content",
  is_sensible: "Explicit & Sensitive Content",
  is_sensible_sub: "Set this item as explicit and sensitive content",
  sensible_tip:
    "Setting your asset as explicit and sensitive content, like pornography and other not safe for work (NSFW) content",
  blockchain: "Blockchain",
  blockchain_sub:
    "Choose the Blockchain where NFT will mint. NFThub will support more Blockchains in the future",
  blockchain_tip: "",
  contract: "SmartContract",
  contract_sub:
    "Choose the Contract where NFT will mint. NFThub will support more SmartContracts in the future",
  contract_tip: "",
  change_owner: "Change NFT owner",
  change_owner_sub:
    "If you do not change the owner, current address is the owner of the newly created NFT",
  mint: "Mint",
  waiting_for_confirm: "Waiting for the wallet to confirm.",
  mint_successful: "Mint successful",
  mint_error:
    "Mint failed, please make sure you have enough TRX to pay for the bandwidth and energy",
  minting: "Minting is in progress, please check later.",
  unMint: "This file has no associated NFT",
  image: "Image",
  audio: "Audio",
  video: "Video",
  document: "Document",
  code: "Code",
  "3d": "3D Model",
  collection: "Collectibles",
  others: "Others",
  NFT_name_null: "Name cannot be empty",
  NFT_category_null: "Category cannot be empty",
  NFT_invalid_chain:
    "The blockchain connected to the wallet is inconsistent with the blockchain where the contract is deployed",
  NFT_invalid_owner: "Invalid address",
  related_contract: "NFT contract associated with this file",
  contract_future:
    "NFT Hub is going to support more Chains and Contracts, as well as more activities in the future",
  view: "View",
  NFT_on_chain: "Your NFT is on chain",
  ok: "ok",
  add_to_link: "Add NFT to Tronlink",
  name_address: "File Name & Address",
  other_operations: "Operation",
  




  // new add in files
  mint_view: "View NFT",
  mint_sell: "Sell NFT",
  sell_own: "Sell",
  price: "Price",
  expiration_date: "Expiration Date",
  fees: "Fees",
  fees_des: "The following fee will be deducted at the time of sale",
  APENFT_service_fee: "APENFT Service Fee",
  copyright_fee: "CopyRight Fee",
  total_fees: "Total Fees",
  listing_btn: "List",
  listing_successful: "Listing Successful!",
  listing_failed: "Listing Failed!",
  already_listed: "Already Listed!",
  price_error_1: "Must be no less than 1",
  price_error_2: "Insufficient Balance",
  price_error_3: "Number too Big",
  expiration_error_1: "Invalid expiration time",
  approve_collection: "Approve Collection",
  confirm_listing: "Confirm Listing",
  approve_collection_des: "Please confirm this transaction to let you sell NFTs of this collection. Every collection only needs to approve one time.",
  approve_des: "To get set up for the first time, you must approve for trading, which requires a one-time gas fee.",
  confirm_des: "Accept the signature request in your wallet and wait for your transaction to process.",
  listing: "Listing",
  approve: "Approve",
  failed: "Failed!",
  retry: 'Retry',
};